import { render, staticRenderFns } from "./allTeacher.vue?vue&type=template&id=c9117e36"
import script from "./allTeacher.vue?vue&type=script&lang=js"
export * from "./allTeacher.vue?vue&type=script&lang=js"
import style0 from "./allTeacher.vue?vue&type=style&index=0&id=c9117e36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports